import { QueryClient } from '@tanstack/react-query';

/**
 * Central QueryClient instance for TanStack Query (React Query).
 * Configured with global defaults for caching, retries, and refetching behavior.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
